<template>
<div class="chapter">
<div class="inner_page">
<div id="Contents">
<p class="fm-title"><b>CONTENTS</b></p>
<table border="0" cellpadding="0" cellspacing="0" width="100%">
<colgroup>
<col width="25%"/>
<col width="75%"/>
</colgroup>
<tbody>
<tr>
<td align="left" valign="top"><p class="toc1"> </p></td>
<td align="left" valign="top"><p class="toc1"><a href="#/xhtml/06_Acknowledgements">Acknowledgements</a></p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="toc1"> </p></td>
<td align="left" valign="top"><p class="toc1"><a href="#/xhtml/07_List_of_Maps">List of Maps</a></p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="toc1"> </p></td>
<td align="left" valign="top"><p class="toc1"><a href="#/xhtml/09_Introduction">Introduction</a></p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="toc1"> </p></td>
<td align="left" valign="top"><p class="toc1"><a href="#/xhtml/10_Historical_Background">Historical Background</a></p></td>
</tr>
<tr>
<td align="right" valign="top"><p class="toc1"><a href="#/xhtml/11_Chapter01"><i>Chapter One</i>   </a></p></td>
<td align="left" valign="top"><p class="toc1"><a href="#/xhtml/11_Chapter01"><b>The Allied Troops and Dispositions</b></a></p></td>
</tr>
<tr>
<td align="right" valign="top"><p class="toc1"><span href="#/xhtml/12_Chapter02" title="Link target outside of Sample"><i>Chapter Two</i>   </span></p></td>
<td align="left" valign="top"><p class="toc1"><span href="#/xhtml/12_Chapter02" title="Link target outside of Sample"><b>The Defence of the Chemin des Dames and Californie Plateau</b></span></p></td>
</tr>
<tr>
<td align="right" valign="top"><p class="toc1"><span href="#/xhtml/13_Chapter03" title="Link target outside of Sample"><i>Chapter Three</i>   </span></p></td>
<td align="left" valign="top"><p class="toc1"><span href="#/xhtml/13_Chapter03" title="Link target outside of Sample"><b>The Defence of the woods and the Aisne River</b></span></p></td>
</tr>
<tr>
<td align="right" valign="top"><p class="toc1"><span href="#/xhtml/14_Chapter04" title="Link target outside of Sample"><i>Chapter Four</i>   </span></p></td>
<td align="left" valign="top"><p class="toc1"><span href="#/xhtml/14_Chapter04" title="Link target outside of Sample"><b>The Defence of the Aisne Canal</b></span></p></td>
</tr>
<tr>
<td align="right" valign="top"><p class="toc1"><span href="#/xhtml/15_Chapter05" title="Link target outside of Sample"><i>Chapter Five</i>   </span></p></td>
<td align="left" valign="top"><p class="toc1"><span href="#/xhtml/15_Chapter05" title="Link target outside of Sample"><b>Rearguard Actions: Afternoon of 27 May – 6 June</b></span></p></td>
</tr>
<tr>
<td align="right" valign="top"><p class="toc1"><span href="#/xhtml/16_General_Advice" title="Link target outside of Sample"><i>Chapter Six</i>   </span></p></td>
<td align="left" valign="top"><p class="toc1"><span href="#/xhtml/16_General_Advice" title="Link target outside of Sample"><b>General Advice for Tourers</b></span></p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="toc1"> </p></td>
<td align="left" valign="top"><p class="toc1"><span href="#/xhtml/17_Car_Tour_1" title="Link target outside of Sample">Car Tour 1</span></p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="toc1"> </p></td>
<td align="left" valign="top"><p class="toc1"><span href="#/xhtml/18_Walk_1" title="Link target outside of Sample">Walking Tour 1</span></p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="toc1"> </p></td>
<td align="left" valign="top"><p class="toc1"><span href="#/xhtml/19_Walk_2" title="Link target outside of Sample">Walking Tour 2</span></p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="toc1"> </p></td>
<td align="left" valign="top"><p class="toc1"><span href="#/xhtml/20_Soissons_Memorial" title="Link target outside of Sample">Soissons Memorial to the Missing</span></p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="toc1"> </p></td>
<td align="left" valign="top"><p class="toc1"><span href="#/xhtml/21_British_Cemeteries" title="Link target outside of Sample">Aisne 1918 British Cemeteries</span></p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="toc1"> </p></td>
<td align="left" valign="top"><p class="toc1"><span href="#/xhtml/22_German_Cemeteries_Associated" title="Link target outside of Sample">German Cemeteries</span></p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="toc1"> </p></td>
<td align="left" valign="top"><p class="toc1"><span href="#/xhtml/23_Order_of_Battle_of_British_Forces" title="Link target outside of Sample">Order of Battle of British Forces</span></p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="toc1"> </p></td>
<td align="left" valign="top"><p class="toc1"><span href="#/xhtml/24_Order_of_Battle_of_German_Infantry_Units" title="Link target outside of Sample">Order of Battle of German Infantry Units</span></p></td>
</tr>
</tbody>
</table>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 05_Contents.vue?fb8f0578